<template>
  <div class="hoder_module">
    <div class="mainTitle">
      {{hoderTitle}}
    </div>
    <div class="subSpace subTitle">
      <span class="mSubStl ">Sharehoder</span>
      <span class="mianColo">&nbsp;Unit</span>
    </div>
    <div>
      <el-row>
        <el-col :span="2">
          &nbsp;
        </el-col>
        <el-col :span="4" v-for="(hoder,index) in hoderArr1" :key="index">
          <a :href="hoder.url" target="_blank">
            <img :src="hoder.path" alt="" class="hoder_icon">
            <div class="title">{{hoder.name}}</div>
          </a>
        </el-col>
        <el-col :span="2">
          &nbsp;
        </el-col>
      </el-row>
    </div>
    <div class="hoder_space">
      <el-row>
        <el-col :span="2">
          &nbsp;
        </el-col>
        <el-col :span="4" v-for="(hoder,index) in hoderArr2" :key="index">
          <a :href="hoder.url" target="_blank">
            <img :src="hoder.path" alt="" class="hoder_icon">
            <div class="title">{{hoder.name}}</div>
          </a>
        </el-col>
        <el-col :span="2">
          &nbsp;
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { homeholder } from '@/api/frontApi/frontHome';
import axios from 'axios';
export default {
  data() {
    return {
      hoderTitle: '股东单位',
      hoderArr1: [
        {
          path: '../../../../static/img/hoder/logo-yto.png',
          name: '中国一拖集团有限公司',
          url: 'http://www.yituo.com.cn/'
        },
        {
          path: '../../../../static/img/hoder/logo-njy.png',
          name: '中国农业机械化科学研究院集团有限公司',
          url: 'http://www.caams.org.cn/'
        },

        {
          path: '../../../static/img/hoder/logo-lw.png',
          name: '洛阳中科龙网创新科技有限公司',
          url: 'http://www.chiaic.com/'
        },
        {
          path: '../../../../static/img/hoder/logo-jsyd.png',
          name: '江苏悦达智能农业装备有限公司',
          url: 'http://www.jm-tractor.com/'
        },
        {
          path: '../../../static/img/hoder/logo-qh.png',
          name: '清研（洛阳）科技产业有限公司',
          url: 'http://www.lamic.com.cn/'
        }
      ],
      hoderArr2: [
        {
          path: '../../../static/img/hoder/logo-nxkj.png',
          name: '农芯科技(北京)有限责任公司',
          url: 'http://www.chiaic.com/'
        },
        {
          path: '../../../../static/img/hoder/logo-zoom.png',
          name: '中联农业机械股份有限公司',
          url: 'http://www.zoomlion-hm.com/'
        },
        {
          path: '../../../static/img/hoder/logo-krm.png',
          name: '无锡卡尔曼导航技术有限公司',
          url: 'https://www.kalman-navigation.com/'
        },
        {
          path: '../../../static/img/hoder/logo-lts.png',
          name: '洛阳拖拉机研究所有限公司',
          url: 'http://www.lts.ac.cn/'
        },
        {
          path: '../../../static/img/hoder/logo-lyzk.png',
          name: '洛阳中科信息产业研究院',
          url: 'http://www.chiaic.com/'
        }
      ],
      masterItems: [],
      masterShow: null,
      holderUrl: '/master/pagemaster.go'
    };
  },
  created() {
    // this.getHolderList();
  },
  methods: {
    getHolderList() {
      // const AaA = axios.create({});
      this.pingtaiArr = [];
      homeholder().then(res => {
        console.log('验证码发送成功');
        console.log(res);
      });
    },
    getHolderList1() {
      const AaA = axios.create({});
      this.pingtaiArr = [];
      AaA({
        url: this.holderUrl,
        methods: 'post'
      }).then(res => {});
    }
  }
};
</script>
<style scoped>
.hoder_module {
  width: 100%;
  height: 100%;
}
.title {
  color: #000;
  font-size: 16px;
  text-align: center;
}
.hoder_space {
  margin: 35px 0 20px 0;
}
.hoder_icon {
  border-radius: 82px;
}
.hoder_icon:hover {
  box-shadow: 0 0 10px #e79734;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/home/shareHoder.vue